/* eslint-disable import/prefer-default-export */
import {
  apiGetAllDocuments,
  apiGetDocumentManagementFiltersDropdown,
  apiGetDocumentManagementTypes,
  apiGetDocumentManagementSources,
  apiGetDocumentManagementStorage,
  apiGetProductFiles,
  apiCreateProductFolder,
} from 'api';
import types from './types';

// GET_ALL_DOCUMENTS
export const getAllDocuments = (filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_ALL_DOCUMENTS,
    asyncCall: () => {
      return apiGetAllDocuments({
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_PENDING_REVIEW_DOCUMENTS
export const getPendingReviewDocuments = (filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_PENDING_REVIEW_DOCUMENTS,
    asyncCall: () => {
      return apiGetAllDocuments({
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_EXPIRED_DOCUMENTS
export const getExpiredDocuments = (filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_EXPIRED_DOCUMENTS,
    asyncCall: () => {
      return apiGetAllDocuments({
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_ARCHIVED_DOCUMENTS
export const getArchivedDocuments = (filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_ARCHIVED_DOCUMENTS,
    asyncCall: () => {
      return apiGetAllDocuments({
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_TRASH_DOCUMENTS
export const getTrashDocuments = (filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_TRASH_DOCUMENTS,
    asyncCall: () => {
      return apiGetAllDocuments({
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_DOCUMENT_MANAGEMENT_FILTERS_DROPDOWN
export const getDocumentManagementFiltersDropdown = (cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_DOCUMENT_MANAGEMENT_FILTERS_DROPDOWN,
    asyncCall: () => {
      return apiGetDocumentManagementFiltersDropdown();
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_DOCUMENT_MANAGEMENT_FILTER_TYPES
export const getDocumentManagementFilterTypes = (filters, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_DOCUMENT_MANAGEMENT_FILTER_TYPES,
    asyncCall: () => {
      return apiGetDocumentManagementTypes(filters);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_DOCUMENT_MANAGEMENT_FILTER_SOURCES
export const getDocumentManagementFilterSources = (cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_DOCUMENT_MANAGEMENT_FILTER_SOURCES,
    asyncCall: () => {
      return apiGetDocumentManagementSources();
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_DOCUMENT_MANAGEMENT_STORAGE
export const getDocumentManagementStorage = (cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_DOCUMENT_MANAGEMENT_STORAGE,
    asyncCall: () => {
      return apiGetDocumentManagementStorage();
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_PRODUCT_ALL_FILES
export const getProductAllFiles = (productId, filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_PRODUCT_ALL_FILES,
    asyncCall: () => {
      return apiGetProductFiles(productId, {
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_PRODUCT_ALL_FILES1
export const getProductAllFiles1 = (productId, filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_PRODUCT_ALL_FILES1,
    asyncCall: () => {
      return apiGetProductFiles(productId, {
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_PRODUCT_ARCHIVED_FILES
export const getProductArchivedFiles = (productId, filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.GET_PRODUCT_ARCHIVED_FILES,
    asyncCall: () => {
      return apiGetProductFiles(productId, {
        ...filters,
      });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// CREATE_PRODUCT_FOLDER
export const createProductFolder = (data, cb) => {
  return {
    isAsyncCall: true,
    baseType: types.CREATE_PRODUCT_FOLDER,
    asyncCall: () => {
      return apiCreateProductFolder(data);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
